import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { queryWorkbench } from '@/api/dashboard/announcementsApi.js';
export default {
  data: function data() {
    var columns = [{
      title: '公告分类',
      dataIndex: 'cateName',
      ellipsis: true,
      align: 'center',
      resizable: true,
      width: 15,
      scopedSlots: {
        customRender: 'cateName'
      }
    }, {
      title: '紧急状态',
      dataIndex: 'emergency',
      ellipsis: true,
      align: 'center',
      resizable: true,
      width: 7,
      scopedSlots: {
        customRender: 'emergency'
      }
    }, {
      title: '标题',
      dataIndex: 'title',
      ellipsis: true,
      align: 'center',
      width: 50
    }, {
      title: '发布时间',
      dataIndex: 'releaseTime',
      ellipsis: true,
      align: 'center',
      width: 10
    }, {
      title: '发布人',
      dataIndex: 'userName',
      ellipsis: true,
      align: 'center',
      width: 10
    }, {
      title: '阅读状态',
      dataIndex: 'viewStatus',
      align: 'center',
      width: 7,
      scopedSlots: {
        customRender: 'viewStatus'
      }
    }, {
      title: '操作',
      dataIndex: '',
      align: 'center',
      width: 10,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      pagination: this.$hdk.page(),
      // pagination: {
      //     total: 0,
      //     defaultPageSize: 10,
      //     showTotal: total => `共 ${total} 条数据`,
      //     showSizeChanger: true,
      //     pageSizeOptions: ['10', '15', '20'],
      //     onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize)
      // },
      expand: false,
      formState: {
        name: '',
        query: '',
        status: undefined,
        time: [],
        emergency: undefined,
        cateId: undefined,
        startTime: '',
        endTime: ''
      },
      text: '',
      columns: columns,
      list: []
    };
  },
  created: function created() {
    this.fetch();
  },
  methods: {
    //跳转至审批页面
    viewAudit: function viewAudit(row) {
      this.$router.push({
        path: '/docNotice/notice/auditNotice',
        query: {
          id: row.id,
          type: 2
        }
      });
    },
    /*
     * 查看通知公告
     */
    view: function view(row) {
      this.$router.push({
        path: '/docNotice/notice/noticeAdd',
        query: {
          id: row.id,
          type: 2,
          look: 'updateWorkbench'
        }
      });
    },
    /**
     * 搜索按钮查询
     */
    search: function search() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.fetch();
    },
    /**
     * 展开收回
     */
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    /**
     * 分页切换
     */
    change: function change(pagination) {
      this.fetch({
        current: pagination.current,
        pageSize: pagination.pageSize,
        formState: this.formState
      });
    },
    /**
     * 列表数据请求
     */
    fetch: function fetch(options) {
      var _this = this;
      var pagination = this.pagination,
        formState = this.formState,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (this.formState.time.length > 0) {
        this.formState.startTime = this.formState.time[0];
        this.formState.endTime = this.formState.time[1];
      } else {
        this.formState.startTime = null;
        this.formState.endTime = null;
      }
      if (!pager.formState) {
        pager.formState = formState;
      }
      queryWorkbench(pager.current, pager.pageSize, pager.formState).then(function (res) {
        _this.list = res.data.data;
        _.assign(pagination, {
          total: res.data.count,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(formState, pager.formState);
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  mounted: function mounted() {}
};